import { useState, useRef, useMemo } from 'react'
import { Props_SnippetDivision } from './Division.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetDivision = (props: Props_SnippetDivision) => {
    const { heading, repeatable_division } = props
    
    const [snippetID] = useState(() => 
        Math.random().toString(36).substring(2, 10)
    );
    
    const classHeadingVisibility: string = heading.visibility.value 
        ? `snippet-division__heading--${heading.visibility.value}` 
        : ''
    

    return (
        <section className={`snippet-division`}>
            <div className="snippet-division__container">
                {heading?.content?.value && (
                    <h2 
                        id={`snippet-division-${snippetID}`}
                        className={`snippet-division__heading ${classHeadingVisibility}`}
                    >
                        {heading.content.value}
                    </h2>
                )}
                
                <div className="snippet-division__grid">
                    {repeatable_division.map((division, index: number) => (
                        <article key={`snippet-division-${snippetID}-${index}`} className="snippet-division__item">
                            {division.image?.value && (
                                <figure className="snippet-division__image-container">
                                    <img
                                        className="snippet-division__image"
                                        loading="lazy"
                                        src={division.image.value}
                                        alt={division.alt?.value || ''}
                                        width="300"
                                        height="200"
                                    />
                                </figure>
                            )}
                            
                            <div className="snippet-division__content">
                                {division.heading?.value && (
                                    <h3 className="snippet-division__title">
                                        {division.heading.value}
                                    </h3>
                                )}
                                
                                {division.content?.value && (
                                    <div className="snippet-division__text">
                                        {Legacy_CompileMarkdown(division.content.value)}
                                    </div>
                                )}
                                
                                {division.linkHref?.value && (
                                
                                        <SnippetLink
                                            linkStyles={division.linkStyle?.value}
                                            className="snippet-division__link"
                                            url={division.linkHref.value}
                                            openInNewTab={division.linkTarget?.value === "true"}
                                            rel={division.linkTarget?.value === "true" ? 'noopener noreferrer' : undefined}
                                            aria-label={`${division.linkText?.value || 'Learn more'} about ${division.heading?.value}`}
                                        >
                                            {division.linkText?.value}
                                        </SnippetLink>
                                
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetDivision
